import { ToastMessage, ToastService } from '@/app/shared/services/toast.service'
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core'

// Suffixe ajouté par l'intercepteur HTTP : « message • (correlationId) ».
const CORRELATION_ID_SUFFIX = / • \(([^)]+)\)\s*$/

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-toast',
  imports: [],
  templateUrl: './toast.html',
  styles: `
    @keyframes toast-in {
      from {
        opacity: 0;
        transform: translateY(-0.5rem) scale(0.97);
      }
      to {
        opacity: 1;
        transform: translateY(0) scale(1);
      }
    }
  `,
})
export class Toast {
  toastService = inject(ToastService)

  // Toast dont le correlationId vient d'être copié (retour visuel bref sur le bouton Copier).
  readonly copiedMsg = signal<ToastMessage | null>(null)

  getToastClasses(type: ToastMessage['type']): string {
    switch (type) {
      case 'success':
        return 'bg-emerald-50 text-emerald-800 border-emerald-200 dark:bg-emerald-950/80 dark:text-emerald-200 dark:border-emerald-800'
      case 'error':
        return 'bg-red-50 text-red-800 border-red-200 dark:bg-red-950/80 dark:text-red-200 dark:border-red-800'
      case 'info':
        return 'bg-indigo-50 text-indigo-800 border-indigo-200 dark:bg-indigo-950/80 dark:text-indigo-200 dark:border-indigo-800'
    }
  }

  /** Extrait le correlationId du suffixe « • (id) » ajouté par l'intercepteur, s'il est présent. */
  correlationId(msg: ToastMessage): string | null {
    return msg.text.match(CORRELATION_ID_SUFFIX)?.[1] ?? null
  }

  async copyCorrelationId(msg: ToastMessage): Promise<void> {
    const id = this.correlationId(msg)
    if (!id) return
    try {
      await navigator.clipboard.writeText(id)
      this.copiedMsg.set(msg)
      setTimeout(() => {
        if (this.copiedMsg() === msg) this.copiedMsg.set(null)
      }, 2000)
    } catch {
      // Presse-papiers indisponible (permissions) : le texte reste sélectionnable à la main.
    }
  }
}
